/**
 * Controller for AppManager
 */
define('controllers/myservices/myservice-list.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('MyServiceList', ['$q', '$scope', '$location', '$stateParams', '$filter', '$state', 'biAnalyticService', 'UserInfoPreload', 'auiDialog', 'OpenApp', 'getServiceList', 'payService', 'auiAgreementHelper', 'serviceresource',
        function ($q, $scope, $location, $stateParams, $filter, $state, biAnalyticService, UserInfoPreload, auiDialog, OpenApp, getServiceList, payService, auiAgreementHelper, serviceresource) {
            var Model = $scope.Model = {};
            var serviceItem = $stateParams.serviceItem;
            var services = mainCons.myserviceList.services;
            var needVerified = mainCons.myserviceRollout.needVerified;
            var isCanQueryList = false;
            biAnalyticService.trackPageView("产品列表", 'MALL0002', serviceItem);

            var currService = {};
            Model.currPage = $location.url().split("/").length;
            services.forEach(function (service) {
                if (service.serviceItem == serviceItem) {
                    Model.currService = angular.copy(service);
                    currService = angular.copy(service);
                }
            });
            Model.harmonyOsCardID = sysParamCfg.harmonyOsCardID;
            if (sysParamCfg.harmonyOsCardID == serviceItem) {
                $state.go('harmonyOsCard');
                return;
            }

            //默认图标过滤器设置
            Model.defaultProductGrayIconFilterMap = mainCons.appConstant.defaultProductGrayIconFilter;
            //服务图标下服务状态值的过滤器
            Model.prodServiceStateValueFilterMap = mainCons.appConstant.serviceStateForManagerFilter;
            //开通未开通状态的设置
            Model.prodServiceopenStateValueFilterMap = mainCons.appConstant.openStateFilter;
            //含有协议button的服务
            var hasAgreementSer = mainCons.myserviceList.hasAgreementSer;
            //产品类型和服务状态
            Model.constant = {
                prodType: mainCons.appConstant.prodType,
                prodState: mainCons.appConstant.prodState,
                serviceItemToAgreement: mainCons.appConstant.serviceItemToAgreement,
                serviceItemToAgreementType: mainCons.appConstant.serviceItemToAgreementType
            };
            Model.verifyRealState = UserInfoPreload.verifyRealState;
            Model.userType = UserInfoPreload.userType;
            Model.app = {
                tableHeader: {
                    productName: {
                        id: "productName",
                        name: "产品名称",
                        width: 210,
                        filterMethod: querySearchList,
                        queryMethod: queryListSec
                    },
                    prodType: {
                        id: "prodType",
                        name: "产品类型",
                        data: currService.prodType.filter(function (item) {
                            return item.switch !== false;
                        }),
                        queryMethod: queryListSec
                    },
                    status: {
                        id: "status",
                        name: "状态",
                        data: currService.serStatus,
                        queryMethod: queryListSec
                    },
                    dateFilter: {
                        id: "dateFilter",
                        name: "更新时间",
                        queryMethod: queryListSec
                    }
                },
                query: {
                    pagination: {
                        currentPage: 1,// 当前页
                        itemsPerPage: 10,// 默认每页个数
                        totalCount: 0,
                        noItems: "No products",
                        pagesLength: 10,// 显示的页码数量,
                        onChange: queryList
                    },
                    tableHeader: {
                        productName: "",
                        prodType: [],
                        status: [],
                        dateFilter: {
                            sortType: 1,//1:按顺序 ， 2：按时间区间
                            sortOrder: 1,//0:按时间新到旧  1：按时间旧到新
                            fromTime: new Date(),
                            toTime: new Date()
                        }
                    }
                }
            };
            //函数区
            $scope.contains = contains;
            //是否分发服务
            $scope.isDistributionService = isDistributionService;
            //上架
            $scope.submitSer = submitSer;
            //升级
            $scope.upgradeSer = submitSer;
            //申请下架
            $scope.pulloffSer = pulloffSer;
            //删除
            $scope.deleteSer = deleteSer;
            //首发重新申请
            $scope.reApplyFirstPublish = reApplyFirstPublish;
            //产品详情
            $scope.prodDetail = prodDetail;

            //新发布服务
            $scope.rollout4New = rollout4New;

            // 跳转支付报表
            $scope.payReportDetail = payReportDetail;


            //获取支付信息
            $scope.getPaymentInfo = payService.getPaymentInfo;


            $scope.showAgreement = showAgreement;

            $scope.queryList = queryList;

            //Model.constant.serviceItemToAgreement[type]
            function showAgreement() {
                var defer = $q.defer();
                if (Model.constant.serviceItemToAgreementType[serviceItem]) {
                    auiAgreementHelper.viewAndDownloadAgreements(Model.constant.serviceItemToAgreementType[serviceItem]).then(function () {
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                } else {
                    defer.reject();
                }

                return defer.promise;

            }

            //新发布服务
            function rollout4New() {
                var defer = $q.defer();
                canRollout().then(function (can) {
                    if (can) {
                        var url = 'rollout.selPkg';
                        if ('30' == serviceItem) {
                            url = 'rollout.selThemePkg';
                        }
                        $state.go(url, {serviceItem: serviceItem});
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                }).catch(function () {
                    defer.reject();
                });
                getServiceList.updateProdcutType(null, serviceItem);

                return defer.promise;
            }

            function canRollout() {
                var defer = $q.defer();
                if (contains(needVerified, serviceItem)) { // 需要实名认证后才能添加
                    if (UserInfoPreload.verifyRealState && UserInfoPreload.verifyRealState == 2) {
                        defer.resolve(true);
                    } else {
                        auiDialog.warn('操作无权限', "您的实名认证信息正在审核中，审核通过后，您才可以申请" + Model.currService.name + "服务。");
                        defer.resolve(false);
                    }
                } else {
                    defer.resolve(true);
                }
                return defer.promise;
            }

            //产品详情
            function prodDetail(product) {
                if (product.prodState == '6' || product.prodState == '3' || product.prodState == '4') return;
                $state.go(currService.prodDetail, {
                    prodID: product.prodID,
                    srvSerialNo: product.serviceSingle.srvSerialNo
                });
            }


            //修改
            function submitSer(product) {
                product.isUpdate = true;
                var url = 'rollout.selPkg';
                if ('30' == serviceItem) {
                    url = 'rollout.selThemePkg';
                }
                $state.go(url, {serviceItem: serviceItem, product: product});
            }

            function payReportDetail() {
                $state.go("myReport.payment", {}, {reload: true});
            }

            function reApplyFirstPublish(product) {
                product.isUpdate = true;
                $state.go('rollout.firstPublishServiceDetail', {serviceItem: serviceItem, product: product});
            }

            //申请下架
            function pulloffSer(prod) {
                getServiceList.pullOff(prod, serviceItem).then(function (res) {
                    if (res) {
                        Model.app.query.pagination.currentPage = 1;
                        queryList();
                    }
                });
            }

            //删除
            function deleteSer(prod) {
                getServiceList.deleteAll(prod).then(function (res) {
                    if (res && res.resultCode == 0) {
                        auiDialog.successAndMark('删除成功', function () {
                            Model.app.query.pagination.currentPage = 1;
                            queryList();
                        }, {isOnShelf: 4});
                    }
                });
            }


            //包含
            function contains(arr, obj) {
                return AUI.BaseJSUtil.contains(arr, obj);
            }


            //查询列表
            function querySearchList() {
                var defer = $q.defer();
                var getSearchListRequest = {};
                //不带分页事件的查询
                getSearchListRequest.request = {
                    searchTxt: Model.app.query.tableHeader.productName,
                    serviceItem: serviceItem
                };

                OpenApp.getProListByService(getSearchListRequest).then(function (data) {
                    var prodNames = [];
                    var productList = data && data.productList;
                    if (productList && productList.length > 0) {
                        for (var i in productList) {
                            prodNames.push(productList[i].prodName);
                        }
                    }
                    defer.resolve(AUI.BaseJSUtil.unique(prodNames));
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function queryListSec() {
                queryList('two');
            }


            //调用产品列表接口
            function queryList(value) {
                if (isCanQueryList) {
                    var defer = $q.defer();
                    var getProductListRequest = {};
                    //带分页事件的查询
                    var request = {
                        fromRecCount: 1 + (Model.app.query.pagination.currentPage - 1) * Model.app.query.pagination.itemsPerPage,
                        maxReqCount: Model.app.query.pagination.itemsPerPage,
                        sortType: Model.app.query.tableHeader.dateFilter.sortOrder,
                        searchTxt: Model.app.query.tableHeader.productName,
                        prodType: Model.app.query.tableHeader.prodType,
                        fromTime: $filter('date')(Model.app.query.tableHeader.dateFilter.fromTime, 'yyyy-MM-ddT00:00:00+0800'),
                        toTime: $filter('date')(Model.app.query.tableHeader.dateFilter.toTime, 'yyyy-MM-ddT23:59:59+0800'),
                        serviceItem: serviceItem
                    };
                    request.serviceStates = Model.app.query.tableHeader.status.join(',').split(',');
                    if ("" == request.serviceStates) {
                        delete request.serviceStates;
                    }
                    if (angular.toJson(request.searchTxt) == '') {
                        delete request.searchTxt;
                    }
                    if (request.prodType.length <= 0) {
                        delete request.prodType;
                    }
                    if (Model.app.query.tableHeader.dateFilter.sortType == 1) {
                        delete request.fromTime;
                        delete request.toTime;
                    }
                    if (request.fromTime && request.toTime) {
                        request.sortType = 1;
                    }

                    if ((request.serviceStates || request.prodType || request.searchTxt || (request.fromTime && request.toTime) || request.sortType == 0 || request.sortType) && value == 'two') {
                        request.fromRecCount = 1;
                        Model.app.query.pagination.currentPage = 1;
                    }
                    getProductListRequest.request = request;
                    Model.app.productList = null;
                    OpenApp.getProListByService(getProductListRequest).then(function (data) {
                        Model.app.productList = data.productList;
                        $scope.productList = angular.copy(data.productList);
                        //写个服务保存一把productList
                        if (Model.app.productList && Model.app.productList.length > 0) {
                            Model.app.productList.forEach(function (pro) {

                                if (pro.prodState == 6) {
                                    pro.contentTip = "产品由于被认领走了，该产品处于失效状态，不允许操作";
                                } else if (pro.prodState == 3 || pro.prodState == 4) {
                                    pro.contentTip = "产品转移中，不允许操作";
                                }

                                // 判断失效的原因，是应用认领失效的还是手动失效的，如果状态是6（失效）同时填写了失效愿意则认为手动失效，否则认为是被认领失效
                                if (pro.prodState == 6) {
                                    if (pro.prodAttrs && angular.fromJson(pro.prodAttrs)) {
                                        pro.invalidReason = "（该产品已经失效）";
                                    } else {
                                        pro.invalidReason = "（该产品已被其他开发者认领）";
                                    }
                                }

                                getServiceList.improveProduct(pro, serviceItem);

                            });
                        }
                        if (value == 'first') {
                            $scope.totalCount = data.totalCount
                        }
                        Model.app.query.pagination.totalCount = data.totalCount;
                        defer.resolve(data);
                    }).catch(function () {
                        Model.app.productList = [];
                        defer.reject();
                    });
                    return defer.promise;
                }

            }

            //getStateValue 判断服务是否是分发服务（推广服务）(服务id,产品类型)
            function isDistributionService(item) {
                return AUI.BaseJSUtil.contains(mainCons.appConstant.growServices, item);
            }

            // 用于控制页面的展示和不展示
            $scope.$on('transfer.myservicesList', function (event, data) {
                Model.currPage = data;
            });


            function initList(type) {
                if (Model.constant.serviceItemToAgreement[type]) {
                    auiAgreementHelper.checkAgreements(Model.constant.serviceItemToAgreement[type], function () {
                        $state.go('serviceCards', {dirId: 'AppService'}, {reload: true});
                    }, null, true).then(function (result) {
                        if (result.signed) {
                            if (serviceItem == 8) {
                                var developerKeyParam = {
                                    keyType: 2
                                };
                                payService.checkSecretKeys();
                                payService.getPayDeveloperKey(developerKeyParam).then(function (resp) {
                                    if (resp.returnCode != 3) {
                                        if (resp.developPubKey && resp.developPubKey != "") {
                                            Model.isHidden = true;
                                        } else {
                                            Model.isHidden = false
                                        }
                                    }

                                });
                            }
                            checkIsHasVrProd();
                        }
                    });
                } else {
                    auiAgreementHelper.checkAgreement(type, function () {
                        if ('30' == type) {
                            $state.go('serviceCards', {dirId: 'ThemeService'}, {reload: true});
                        } else {
                            $state.go('serviceCards', {dirId: 'AppService'}, {reload: true});
                        }
                    }).then(function (result) {
                        if (result.signed) {
                            checkIsHasVrProd();
                        }
                    });
                }
            }

            function checkIsHasVrProd() {
                getServiceList.checkIsHasVrProd(serviceItem).then(function (res) {
                    if (res && res.retCount > 0) {
                        auiAgreementHelper.checkAgreement(48, function () {
                            $state.go("home");
                        }).then(function (data) {
                            if (data.signed) {
                                inlistAndgetAgreeStatus();
                            }
                        })
                    } else {
                        inlistAndgetAgreeStatus();
                    }
                });
            }

            //加载列表和获取协议显示状态
            function inlistAndgetAgreeStatus() {
                var header = getServiceList.getProductType(serviceItem);
                if (header && header.dateFilter) {
                    Model.app.query.tableHeader = angular.copy(getServiceList.getProductType(serviceItem));
                }

                if (serviceItem == 4) {
                    auiAgreementHelper.queryAgreements([auiAgreementHelper.judgeAgreementByServiceItem(8), auiAgreementHelper.judgeAgreementByServiceItem(48)]).then(function (res) {
                        if (res && res.signInfoList && res.signInfoList.length > 0) {
                            angular.forEach(res.signInfoList, function (signInfo) {
                                if (signInfo.signStatus != 3) {
                                    Model.isShowAgreeBut = true;
                                }
                            });
                        }
                    });
                } else {
                    Model.isShowAgreeBut = AUI.BaseJSUtil.contains(hasAgreementSer, serviceItem);

                }
                isCanQueryList = true;
                queryList('first');
            }

            $scope.$watch("Model.app.query.tableHeader", function (n, o) {
                if (n && o && !angular.equals(n, o)) {
                    getServiceList.updateProdcutType(n, serviceItem);
                }
            }, true);
            //初始化方法
            !function () {
                if (serviceItem == 8 ) {//如果是支付的走这里 兼容方案吧  后面改掉
                    $state.go('myServiceListPay');
                    return;
                }
                if (serviceItem == 32 ) {//下个版本修改 如果是支付的走这里 兼容方案吧  后面改掉  && sysParamCfg.switchConf.angularHandover
                    $state.go('myServiceListId');
                    return;
                }
                // 权限判断
                serviceresource.cache.getData().then(function (res) {
                    var exist = false,
                        hash = window.location.hash,
                        hashTempArr = hash.split('/'),
                        serviceCards = res.data.serviceCards || [],
                        reportCards = res.data.reportCards || [];
                    if (hashTempArr.length > 3) {
                        hash = hashTempArr[0] + '/' + hashTempArr[1] + '/' + hashTempArr[2]
                    }
                    loop: for (var i = 0, all = serviceCards.concat(reportCards); i < all.length; i++) {
                        for (var j = 0, categorys = all[i].resourceTree; j < categorys.length; j++) {
                            for (var k = 0, cards = categorys[j].cards; k < cards.length; k++) {
                                if (cards[k].link.url === hash) {
                                    exist = true;
                                    break loop;
                                }
                            }
                        }
                    }

                    if (!exist) {
                        auiDialog.warn('您好！您暂未开通此服务权限，如需使用此功能，请通过客服支持联系我们。', function () {
                            if ($scope.mainUserID) {
                                $state.go('mysetting.userInfo');
                            } else {
                                $state.go('home');
                            }
                        });
                        return;
                    }

                    getServiceList.checkPaidService(serviceItem).then(function (res) {
                        if (res.checkResult == 1) {
                            initList(8);
                        } else if (serviceItem == 45) {//杂志锁屏 不签署协议
                            initList();
                        } else if (serviceItem == 8) {
                            payService.checkPayService(function () {
                                initList(serviceItem);
                            });
                        } else {
                            initList(serviceItem);
                        }
                    })
                });

            }()
        }]);
});

